import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { ExternalCourseParticipantsListPayload } from 'store/actions/externalCourseParticipant.action'
import { UploadCertificatesModal } from '../../../common'

interface UploadButtonProps {
  externalCourse: ExternalCourseModelAPI
  participantList?: ExternalCourseParticipantsListPayload
}

export const UploadCertificates: React.FC<UploadButtonProps> = ({
  externalCourse,
  participantList,
}) => {
  const tUpload = useTranslationRankmi({
    prefix: 'administration.externalCourses.list.uploadCertificates',
  })

  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <Dropdown.Item onClick={handleShow}>{tUpload('label')}</Dropdown.Item>
      <UploadCertificatesModal
        show={show}
        externalCourse={externalCourse}
        participantList={participantList}
        onClose={() => {
          handleClose()
        }}
      />
    </>
  )
}

export default UploadCertificates
